"use client";
import React from "react";
import Image from "next/image";
export default function Controllers(props) {
  let controllers = props.data.controllers.data;
  return (
    <div className="section-padded controller-options" id="controller">
      <span className="section-title">Choose Your Controller</span>
      <div className="options-wrapper">
        {controllers.map((controller) => (
          <div className="option" key={controller.id}>
            <div className="option-image-wrapper">
              <Image
                src={controller.attributes.image.data.attributes.url}
                alt={
                  controller.attributes.image.data.attributes.alternativeText ||
                  `FactoryCat Floor Scrubbers - ${controller.attributes.title}`
                }
                width={500}
                height={500}
              />
            </div>
            <div>
              <h4>
                {controller.attributes.title
                  .replace(/(rider| walkie |compact | stick )$/, "")
                  .trim()}
              </h4>
              <p>{controller.attributes.sub_title}</p>
              {controller.attributes.description.map((desc) => (
                <p key={desc.id}>{desc.paragraph}</p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
